import { sharedEs } from './es';
import { sharedPt } from './pt';

export const sharedLocale = {
  pt: sharedPt,
  es: sharedEs,
  'es-CR': {} as typeof sharedEs,
  'es-UY': {} as typeof sharedEs,
};
